module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ef-Gb.b15d5d9f.png";